// Import all Web Components
import '../components/Header.js';
import '../components/Footer.js';
import '../components/SideNav.js';
import '../components/PageNav.js';
import '../components/Pagination.js';
import '../components/MediaContainer.js';

// Set up page scrolling for PageNav
document.addEventListener('DOMContentLoaded', () => {
    // Handle smooth scrolling for in-page navigation
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                window.scrollTo({
                    top: targetElement.offsetTop - 80, // Offset for header
                    behavior: 'smooth'
                });
            }
        });
    });
});
